<template>
  <div class="customer-updates">
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      <!-- Customer Updates -->
      {{ titleHero }}
      <div class="column buttons" slot="right">
        <b-button
          v-if="!messageEdit && !isFromDashboard"
          type="is-link"
          class="actionBtn"
          @click="exportData()"
          >Export</b-button
        >
        <b-button
          v-if="
            !messageEdit &&
              messageStatus != 'sent' &&
              isEditable &&
              !isFromDashboard
          "
          type="is-info"
          class="actionBtn"
          @click="editMessage(1)"
          >Edit</b-button
        >
        <b-button
          v-if="
            !messageEdit &&
              messageStatus == 'done' &&
              action != 'View' &&
              !isFromDashboard &&
              loadingButton == false
          "
          type="is-success"
          class="actionBtn"
          @click="sendMessage()"
          >Send</b-button
        >
        <b-button
          v-if="
            !messageEdit &&
              messageStatus == 'done' &&
              action != 'View' &&
              loadingButton == true
          "
          loading
          type="is-success"
          class="actionBtn"
          @click="sendMessage()"
          >Send</b-button
        >
        <b-button
          v-if="messageEdit"
          type="is-success"
          class="actionBtn"
          @click="saveMessage('done')"
          >Save</b-button
        >
        <b-button
          v-if="messageEdit"
          type="is-normal"
          class="actionBtn"
          @click="saveMessage('draft')"
          >Save as draft</b-button
        >
        <b-button
          v-if="messageEdit"
          type="is-danger"
          class="actionBtn"
          @click="cancelMessage()"
          >Cancel</b-button
        >
        <b-button
          type="is-primary"
          @click="$router.go(-1)"
          v-if="!isFromDashboard"
        >
          <span>Back</span>
        </b-button>
        <b-button type="is-primary" @click="redirectToDashboard()" v-else>
          <span>Back</span>
        </b-button>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div class="columns">
        <div class="column">
          <b-field label="Subject">
            <b-input
              name="subject"
              :disabled="isEdit"
              expanded
              v-model="subject"
              required
            >
            </b-input>
          </b-field>
          <b-field class="msg" label="Update for Customers">
            <vue-editor
              v-model="message"
              required
              :editor-toolbar="editorToolbar"
              :disabled="isEdit"
            />
          </b-field>
          <b-field label="Attachment">
            <b-upload
              v-model="file"
              class="file-label"
              multiple
              drag-drop
              :disabled="isEdit"
              ><span>
                <section class="section">
                  <div class="content has-text-centered">
                    <p>
                      <b-icon icon="upload" size="is-large"> </b-icon>
                    </p>
                    <p>Drop your files here or click to upload</p>
                  </div>
                </section></span
              >
            </b-upload>
          </b-field>
          <b-field>
            <div class="tags" v-if="attachments">
              <span
                v-for="(file, index) in file"
                :key="index"
                class="tag is-primary download-document"
              >
                <span @click.prevent="downloadProof(file)">
                  {{ file.name }}
                </span>
                <button
                  v-if="!isEdit"
                  class="delete is-small"
                  type="button"
                  @click="deleteFromFile(index)"
                ></button>
              </span>
              <div v-if="attachments.length > 0">
                <span
                  v-for="(file, index) in attachments"
                  :key="index"
                  class="tag is-primary download-document"
                >
                  <span @click.prevent="downloadProof(file)">
                    {{ file.attachment }}
                  </span>
                  <button
                    v-if="!isEdit"
                    class="delete is-small"
                    type="button"
                    @click="deleteFromAttachments(index)"
                  ></button>
                </span>
              </div>
            </div>
          </b-field>

          <b-field v-if="!this.isUserExternal" label="Update Type">
            <b-select
              required
              placeholder="Select update type"
              v-model="updateType"
              :disabled="isEdit"
              expanded
            >
              <option value="reporting" key="1">Reporting Updates</option>
              <option value="regulatory" key="2">Regulatory Updates</option>
            </b-select>
          </b-field>

          <b-field
            v-if="!this.isUserExternal"
            label="Recipient Type"
            @change="switchOptions"
          >
            <b-select
              required
              placeholder="Select a recipient type"
              v-model="recipientType"
              @input="switchOptions"
              :disabled="isEdit"
              expanded
            >
              <option value="country" key="4">Country</option>
              <option value="scheme" key="1">Scheme</option>
              <option value="stream" key="3">Stream</option>
              <option value="customer" key="2">Customer</option>
            </b-select>
          </b-field>

          <b-field
            v-if="recipientType == 'customer' && !this.isUserExternal"
            label="Customers"
          >
            <multiselect
              ref="multiselect"
              v-model="selectedCustomers"
              :options="customers"
              placeholder="Select"
              label="name"
              track-by="name"
              :searchable="true"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :hide-selected="true"
              :show-labels="false"
              data-cy="filter-customers"
              openDirection="below"
              :disabled="isEdit"
            >
              <span
                class="checkbox-label"
                slot="option"
                slot-scope="scope"
                :class="{ 'background-inactive': !scope.option.active }"
                :title="scope.option.name"
              >
                {{ scope.option.name }}
              </span>
            </multiselect>
          </b-field>
          <b-field
            v-if="recipientType == 'scheme' && !this.isUserExternal"
            label="Schemes"
          >
            <b-select
              multiple
              placeholder="Select schemes"
              v-model="selectedSchemes"
              :disabled="isEdit"
              @input="updateCustomers"
              expanded
            >
              <option
                v-for="(option, index) in schemes"
                :value="option.id"
                :key="index"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>

          <b-field
            v-if="recipientType == 'country' && !this.isUserExternal"
            label="Countries"
          >
            <b-select
              multiple
              placeholder="Select countries"
              v-model="selectedCountries"
              :disabled="isEdit"
              expanded
              @input="updateCustomers"
            >
              <option
                v-for="(option, index) in countries"
                :value="option.id"
                :key="index"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field
            v-if="
              (recipientType == 'stream' ||
                recipientType == 'scheme' ||
                recipientType == 'country') &&
                !this.isUserExternal
            "
            label="Streams"
          >
            <b-select
              multiple
              placeholder="Select streams"
              v-model="selectedStreams"
              :disabled="isEdit"
              @input="updateCustomers"
              expanded
            >
              <option
                v-for="(option, index) in containers"
                :value="option.id"
                :key="index"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field
            label="Customer Type"
            placeholder="Select customer type"
            v-if="
              (recipientType == 'stream' ||
                recipientType == 'scheme' ||
                recipientType == 'country') &&
                !this.isUserExternal
            "
          >
            <b-select
              placeholder="Select customer type"
              v-model="selectedCustomerType"
              :disabled="isEdit"
              @input="updateCustomers"
              expanded
            >
              <option
                v-for="(option, index) in allCustomerTypes"
                :value="option"
                :key="index"
              >
                {{ option }}
              </option>
            </b-select>
          </b-field>

          <b-field
            label="Landbell Entity"
            placeholder="Select landbell entity"
            v-if="
              (recipientType == 'stream' ||
                recipientType == 'scheme' ||
                recipientType == 'country') &&
                !this.isUserExternal
            "
          >
            <b-select
              required
              multiple
              placeholder="Select landbell entity"
              v-model="selectedLandbellEntity"
              :disabled="isEdit"
              @input="updateCustomers"
              expanded
            >
              <option
                v-for="(option, index) in allLandbellEntities"
                :value="option"
                :key="index"
              >
                {{ option }}
              </option>
            </b-select>
          </b-field>
          <b-field
            v-if="this.recipientType !== 'customer' && !this.isUserExternal"
            label="Customers"
            :disabled="isEdit"
            class="taginput-fix-height"
          >
            <multiselect
              ref="multiselect"
              v-model="selectedCustomers"
              :options="customers"
              placeholder="Select"
              label="name"
              track-by="name"
              :searchable="true"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :hide-selected="true"
              :show-labels="false"
              data-cy="filter-customers"
              openDirection="below"
              :disabled="isEdit"
            >
              <span
                class="checkbox-label"
                slot="option"
                slot-scope="scope"
                :class="{ 'background-inactive': !scope.option.active }"
                :title="scope.option.name"
              >
                {{ scope.option.name }}
              </span>
            </multiselect>
          </b-field>
        </div>
        <div class="column"></div>
      </div>
    </section>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="true">
    </b-loading>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
import HeroBar from "@/components/HeroBar";
import TitleBar from "@/components/TitleBar";
import SchemeDataService from "../../services/SchemeDataService";
import StreamDataService from "../../services/ContainerDataService";
import CountryDataService from "../../services/CountryDataService";
import CustomerUpdatesDataService from "../../services/CustomerUpdatesDataService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import Multiselect from "vue-multiselect";
import ScopeMixin from "@/mixins/scopeMixin";
export default {
  name: "CustomerUpdatesAdd",
  components: { HeroBar, TitleBar, Multiselect, VueEditor },
  mixins: [ScopeMixin],
  props: {
    isFromDashboard: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal"
    ]),
    titleStack() {
      let lastCrumb;
      if (this.id) {
        if (this.action == "View") {
          lastCrumb = "View";
        } else {
          lastCrumb = "Edit";
        }
      } else {
        lastCrumb = "Add";
      }
      return [
        { url: "/reportingtracker", name: "Reporting Tracker" },
        { url: "/", name: "Customer Updates" }
      ];
    },

    titleHero() {
      let subTitle;
      if (this.isUserExternal) {
        subTitle = "Customer Update";
        return subTitle;
      }
      if (this.id && this.url.includes("/customer/updates/edit/")) {
        subTitle = "Edit Customer Update";
      } else if (this.id && this.url.includes("/customer/updates/view/")) {
        subTitle = "View Customer Update";
      } else {
        subTitle = "Add Customer Update";
      }
      return subTitle;
    },
    action() {
      let action;
      if (this.id && this.url.includes("/customer/updates/edit/")) {
        if (this.isUserExternal) {
          this.redirectToDashboard();
        } else {
          action = "Edit";
        }
        if (this.$route.query.plan) {
          this.editMessage();
        } else {
          this.editMessage(1);
        }
      } else if (this.id && this.url.includes("/customer/updates/view/")) {
        action = "View";
      } else {
        if (this.isUserExternal) {
          if (this.id && this.url.includes("/customerupdates/view/")) {
            action = "View";
          }
        }
        action = "Add";
      }
      return action;
    },
    isEditable() {
      if (this.action == "View") {
        return false;
      } else {
        return true;
      }
    }
  },
  ready() {
    this.fetchCustomerProfileData();
    this.getMessages();
    this.fetchSchemes();
  },
  mounted() {
    this.fetchContainers();
    this.fetchCustomerProfileData();
    this.fetchCountries();
    this.fetchSchemes();
    this.getMessages();
    this.fetchScopes();
  },
  data() {
    return {
      isLoading: false,
      scopes: [],
      file: [],
      isModalActive: false,
      actionType: "view",
      id: this.$route.params.id,
      url: window.location.href,
      schemeDataService: new SchemeDataService(),
      streamDataService: new StreamDataService(),
      countryDataService: new CountryDataService(),
      customerDataService: new CustomerProfileDataService(),
      customerUpdatesDataService: new CustomerUpdatesDataService(),
      loadingButton: false,
      isEdit: true,
      messageEdit: false,
      updateCreated: false,
      isComponentModalActive: true,
      customerUpdateEditId: this.$route.params.id,
      subject: null,
      message: null,
      updateType: null,
      recipientType: null,
      messageStatus: null,
      customerUpdate: null,
      customerUpdateId: null,
      fileName: null,
      attachments: [],
      schemes: [],
      streams: [],
      contacts: [],
      customers: [],
      countries: [],
      customerUpdates: [],
      selectedSchemes: [],
      selectedCountries: [],
      selectedCustomers: [],
      selectedCustomerType: [],
      selectedLandbellEntity: [],
      allCustomerTypes: {
        all: "All",
        small: "Small Customer",
        large: "Large Customer",
        europlus_small: "Small - EuropePlus Customer",
        flat_rate_small: "Small - Flat Rate Customer"
      },
      allLandbellEntities: {
        not_entity: " ",
        hc: "H2C",
        sas: "SAS",
        lb: "LB",
        uk: "UK",
        Topengi: "Topengi",
        amazon_marketplace: "Amazon Marketplace",
        general_marketplace: "General Marketplace",
        erp_uk: "ERP UK"
      },
      filteredTags: [],
      editorToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ color: [] }]
      ]
    };
  },
  methods: {
    redirectToDashboard() {
      this.$router.push({ name: "home" });
    },
    fetchScopes() {
      this.customerUpdatesDataService.getCustomerScopes().subscribe(
        response => {
          this.scopes = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    exportData() {
      try {
        this.customerUpdatesDataService.exportgetData(this.customerUpdate.id);
        this.$buefy.toast.open({
          message: "Downloading is in progress...",
          type: "is-success"
        });
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    deleteFromAttachments(index) {
      this.attachments.length > 0 && this.attachments.splice(index, 1);
    },
    deleteFromFile(index) {
      this.file.length > 0 && this.file.splice(index, 1);
    },
    showConvertedMessage() {
      const objAsHtml = "<div>" + this.message + "</div>";
      this.$buefy.dialog.alert({
        title: "Update for customers",
        message: objAsHtml
      });
    },
    downloadProof(file) {
      try {
        this.customerUpdatesDataService.exportProofOfSubmission(
          this.customerUpdate.id,
          file
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    updateCustomers() {
      let selCustomers = null;
      let customerIds = null;
      if (this.recipientType == "scheme") {
        if (this.selectedStreams.length > 0) {
          selCustomers = this.customers.filter(data => {
            const scopes = data.scope_scheme.filter(schemeId => {
              return this.selectedSchemes.includes(parseInt(schemeId));
            });
            return scopes && scopes.length > 0;
          });

          selCustomers = selCustomers.filter(data => {
            const streams = data.scope_stream.filter(streamId => {
              return this.selectedStreams.includes(parseInt(streamId));
            });
            return streams && streams.length > 0;
          });
        } else {
          selCustomers = this.customers.filter(data => {
            const scopes = data.scope_scheme.filter(schemeId => {
              return this.selectedSchemes.includes(parseInt(schemeId));
            });
            return scopes && scopes.length > 0;
          });
        }
        customerIds = selCustomers.map(a => a.id);
      } else if (this.recipientType == "stream") {
        selCustomers = this.customers.filter(data => {
          const scopes = data.scope_stream.filter(streamId => {
            return this.selectedStreams.includes(parseInt(streamId));
          });
          return scopes && scopes.length > 0;
        });
        customerIds = selCustomers.map(a => a.id);
      } else if (this.recipientType == "country") {
        selCustomers = this.scopes.filter(
          scope =>
            this.selectedCountries.includes(scope.country) &&
            this.selectedStreams.includes(scope.stream)
        );
        customerIds = selCustomers.map(a => a.customer);
      }
      if (this.selectedCustomerType != "All") {
        const filteredCustomers = this.customers.filter(data =>
          customerIds.includes(data.id)
        );
        selCustomers = filteredCustomers.filter(
          data => data.customer_type == this.selectedCustomerType
        );
        customerIds = selCustomers.map(a => a.id);
      }

      if (this.selectedLandbellEntity.length != 0) {
        const filteredCustomers = this.customers.filter(data =>
          customerIds.includes(data.id)
        );
        selCustomers = filteredCustomers.filter(data =>
          this.selectedLandbellEntity.includes(data.landbell_entity)
        );
        customerIds = selCustomers.map(a => a.id);
      }

      this.selectedCustomers = this.customers.filter(item =>
        customerIds.includes(item.id)
      );
      this.selectedCustomerIds = this.selectedCustomers.map(a => a.id);
    },
    fieldSorter(fields) {
      return function(a, b) {
        return fields
          .map(function(o) {
            let dir = 1;
            if (o[0] === "-") {
              dir = -1;
              o = o.substring(1);
            }
            if (a[o] > b[o]) return dir;
            if (a[o] < b[o]) return -dir;
            return 0;
          })
          .reduce(function firstNonZeroValue(p, n) {
            return p ? p : n;
          }, 0);
      };
    },
    getMessages() {
      this.customerUpdatesDataService.get(this.customerUpdateEditId).subscribe(
        response => {
          this.customerUpdate = response;
          this.attachments = this.customerUpdate.attachments;
          this.subject = this.customerUpdate.subject;
          this.message = this.customerUpdate.message;
          this.customerUpdateId = this.customerUpdate.id;
          this.messageStatus = this.customerUpdate.status;
          this.selectedSchemes = this.customerUpdate.schemes.map(a => a.id);
          this.selectedStreams = this.customerUpdate.streams.map(a => a.id);
          this.selectedCountries = this.customerUpdate.countries.map(a => a.id);
          this.selectedCustomers = this.customerUpdate.customers;
          this.updateType = this.customerUpdate.update_type;
          this.recipientType = this.customerUpdate.recipient_type;
          this.selectedCustomerType = this.customerUpdate.customer_type;
          this.selectedLandbellEntity = this.customerUpdate.landbell_entity;
        },
        e => {
          console.log(e);
        }
      );
    },
    editMessage(type) {
      if (type == 1) {
        this.isEdit = false;
        this.messageEdit = true;
      } else {
        this.isEdit = true;
        this.messageEdit = false;
      }
    },
    routeToCustomerUpdateList() {
      this.$router.push({
        name: "reportingTracker.customerUpdates1"
      });
    },
    saveMessage(status) {
      this.isLoading = true;
      let msg = "Following fields are mandatory <br/><br/>";
      if (this.subject == null || this.subject == "") {
        msg += " -  Subject <br/>";
      }
      if (this.message == null || this.message == "") {
        msg += " -  Message <br/>";
      }
      if (this.updateType == "" || this.updateType == null) {
        msg += " -  Update Type <br/>";
      }
      if (this.recipientType == "" || this.recipientType == null) {
        msg += " -  Recipient Type <br/>";
      }

      // Check attachment size - limit is 20MB
      let totalSize = 0;

      // Calculate size of new file uploads
      if (this.file && Array.isArray(this.file)) {
        totalSize += this.file.reduce((sum, file) => sum + (file.size || 0), 0);
      }

      // Calculate size of existing attachments (if they have size property)
      if (this.attachments && Array.isArray(this.attachments)) {
        totalSize += this.attachments.reduce(
          (sum, file) => sum + (file.size || 0),
          0
        );
      }

      const maxSize = 20 * 1024 * 1024; // 20MB in bytes

      if (totalSize > maxSize) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please reduce attachment size. Limit is 20MB.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        this.isLoading = false;
        return -1;
      }

      if (
        this.message == null ||
        this.subject == null ||
        this.message == "" ||
        this.subject == ""
      ) {
        this.isLoading = false;
        this.$buefy.dialog.alert({
          title: "Error",
          message: msg,
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return -1;
      } else {
        this.isEdit = true;
        this.messageStatus = status;
        const contactIds = this.contacts.map(a => a.id);
        let selectedCustomerstoSent = null;

        this.selectedCustomerIds = this.selectedCustomers.map(a => a.id);
        selectedCustomerstoSent = this.selectedCustomerIds;

        const payload = {
          status: status,
          attachments: this.attachments,
          contacts: contactIds,
          subject: this.subject,
          message: this.message,
          id: this.customerUpdateId,
          schemes: this.selectedSchemes,
          streams: this.selectedStreams,
          countries: this.selectedCountries,
          update_type: this.updateType,
          recipient_type: this.recipientType,
          customers: selectedCustomerstoSent,
          customer_type: this.selectedCustomerType,
          landbell_entity: this.selectedLandbellEntity
        };
        this.customerUpdatesDataService
          .update(this.customerUpdateEditId, payload, this.file)
          .subscribe(response => {
            this.$buefy.toast.open({
              message: "Data is edited successfully!",
              type: "is-success"
            });
            this.isLoading = false;
            this.messageEdit = false;
            this.updateCreated = true;
          }, this.handleApiError);
      }
    },
    sendMessage() {
      this.loadingButton = true;
      this.customerUpdatesDataService
        .send(this.customerUpdateId)
        .subscribe(response => {
          if (response == 400) {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Email limit exceeds or temporary blockage",
              onConfirm: this.routeToCustomerUpdateList()
            });
          } else {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Update sent successfully to customers!",
              onConfirm: this.routeToCustomerUpdateList()
            });
          }
        }, this.handleApiError);
    },
    resetEditor() {
      this.messageStatus = "sent";
    },
    cancelMessage() {
      this.isEdit = false;
      this.messageEdit = false;
    },

    switchOptions() {
      if (this.recipientType == "scheme") {
        this.selectedCustomers = [];
        this.selectedCountries = [];
        this.selectedStreams = [];
        this.fetchSchemes();
        this.fetchContainers();
      } else if (this.recipient_type == "customer") {
        this.selectedSchemes = [];
        this.selectedCountries = [];
        this.selectedStreams = [];
        this.selectedCustomers = [];
        this.fetchCustomerProfileData();
      } else if (this.recipient_type == "stream") {
        this.selectedSchemes = [];
        this.selectedCountries = [];
        this.selectedCustomers = [];
        this.fetchContainers();
      } else {
        this.selectedSchemes = [];
        this.selectedCustomers = [];
        this.selectedStreams = [];
        this.fetchCountries();
      }
    },

    handleApiError(reason) {
      this.isLoading = false;
      let errorMessage = undefined;
      if (
        reason.response.status == 403 &&
        reason.response.data.code == "token_not_valid"
      ) {
        alert("Session expired, please login again");
        this.authService.logout(this.$keycloak);
        return;
      }
      try {
        errorMessage = reason.response.data["detail"];
      } catch (error) {
        errorMessage = reason.response.data["name"][0];
      } finally {
        errorMessage = reason.response.data["detail"];

        if (errorMessage == null || errorMessage == undefined) {
          errorMessage = "Invalid input";
        }

        this.$buefy.dialog.alert({
          title: "Error",
          message: errorMessage,
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
      return -1;
    }
  }
};
</script>
